(function () {
  'use strict';

  /**
   * Line item properties only — no form submit / add-to-cart listeners.
   * Custom horizontal slider (no Swiper) so card clicks stay reliable.
   */

  function AromaBundlePicker(root) {
    this.root = root;
    this.formId = root.dataset.formId;
    this.form = null;
    this.propertiesMount = null;
    this.steps = Array.from(root.querySelectorAll('[data-aroma-bundle-step]'));
    this.productSection = root.closest('.product-section');
    this.ensureForm();
    this.init();
  }

  AromaBundlePicker.prototype.ensureForm = function () {
    if (this.form) return true;

    if (this.formId) {
      this.form = document.getElementById(this.formId);
    }
    if (!this.form && this.productSection) {
      this.form = this.productSection.querySelector('form.product-single__form');
    }
    if (this.form) {
      this.propertiesMount =
        this.form.querySelector('[data-aroma-bundle-properties-mount]') || this.form;
      if (!this.productSection) {
        this.productSection = this.form.closest('.product-section');
      }
    }
    return !!this.form;
  };

  AromaBundlePicker.prototype.init = function () {
    var self = this;
    if (!this.steps.length) return;

    this.root.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-aroma-slider-prev], [data-aroma-slider-next]')) return;

      var itemEl = evt.target.closest('[data-aroma-bundle-item]');
      if (!itemEl || !self.root.contains(itemEl)) return;
      if (itemEl.dataset.available === 'false') return;

      evt.preventDefault();
      evt.stopPropagation();

      var groupEl = itemEl.querySelector('.biscuits-bundle-item__container-group');
      var stepEl = itemEl.closest('[data-aroma-bundle-step]');
      if (!stepEl || !groupEl) return;

      var maxSel = parseInt(stepEl.dataset.maxSelections, 10) || 1;
      var checkbox = itemEl.querySelector('[data-aroma-item-checkbox]');
      if (!checkbox) return;

      var isSelected = checkbox.checked;

      if (maxSel === 1) {
        if (isSelected) {
          self.setItemSelected(itemEl, groupEl, false);
        } else {
          self.clearStepSelection(stepEl, itemEl);
          self.setItemSelected(itemEl, groupEl, true);
        }
      } else {
        self.setItemSelected(itemEl, groupEl, !isSelected);
        self.enforceMaxSelections(stepEl);
      }

      self.syncLineItemProperties();
      self.updateStepCount(stepEl);
      self.updateAddToCartState();
      self.updateBundleStatus();
    });

    this.root.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      var groupEl = evt.target.closest('.biscuits-bundle-item__container-group');
      if (!groupEl || !self.root.contains(groupEl)) return;
      evt.preventDefault();
      groupEl.click();
    });

    this.steps.forEach(function (stepEl) {
      self.initCustomSliderForStep(stepEl);
    });

    this.bindVariantChange();
    this.bindCartRefresh();
    this.updateAddToCartState();
    this.updateBundleStatus();
    if (this.form) this.syncLineItemProperties();
  };

  AromaBundlePicker.prototype.bindCartRefresh = function () {
    var self = this;
    if (!this.ensureForm() || this.form.dataset.aromaCartHook === 'true') return;
    this.form.dataset.aromaCartHook = 'true';

    this.form.addEventListener('ajaxProduct:added', function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    });

    this.form.addEventListener('ajaxProduct:error', function (evt) {
      var msg =
        evt.detail && evt.detail.errorMessage
          ? evt.detail.errorMessage
          : 'Could not add to cart. Please check your selections.';
      if (typeof msg === 'string' && msg.length) {
        console.warn('[aroma-bundle]', msg);
      }
    });
  };

  AromaBundlePicker.prototype.bindVariantChange = function () {
    var self = this;
    if (!this.productSection || this.productSection.dataset.aromaBundleVariantHook === 'true') return;
    this.productSection.dataset.aromaBundleVariantHook = 'true';
    this.productSection.addEventListener('variantChange', function () {
      window.setTimeout(function () {
        self.updateAddToCartState();
        self.updateBundleStatus();
      }, 0);
    });
  };

  AromaBundlePicker.prototype.getStepSelectionSummary = function () {
    var parts = [];
    this.steps.forEach(function (stepEl) {
      var stepTitle = stepEl.dataset.stepTitle || 'Step';
      var checked = stepEl.querySelector('[data-aroma-item-checkbox]:checked');
      if (!checked) return;
      var item = checked.closest('[data-aroma-bundle-item]');
      var value = item ? (item.dataset.itemTitle || '').trim() : '';
      if (value) parts.push({ label: stepTitle, value: value });
    });
    return parts;
  };

  AromaBundlePicker.prototype.getIncompleteStepTitles = function () {
    var missing = [];
    var self = this;
    this.steps.forEach(function (stepEl) {
      var required = stepEl.dataset.required !== 'false';
      if (!required) return;
      var minSel = parseInt(stepEl.dataset.minSelections, 10) || 1;
      if (self.getStepSelectedCount(stepEl) < minSel) {
        missing.push(stepEl.dataset.stepTitle || 'Required step');
      }
    });
    return missing;
  };

  AromaBundlePicker.prototype.getStepSelectedCount = function (stepEl) {
    var checked = stepEl.querySelectorAll('[data-aroma-item-checkbox]:checked').length;
    if (checked > 0) return checked;
    return stepEl.querySelectorAll('[data-aroma-bundle-item].biscuits--active').length;
  };

  AromaBundlePicker.prototype.isStepComplete = function (stepEl) {
    var required = stepEl.dataset.required !== 'false';
    if (!required) return true;
    var minSel = parseInt(stepEl.dataset.minSelections, 10) || 1;
    return this.getStepSelectedCount(stepEl) >= minSel;
  };

  AromaBundlePicker.prototype.arePriorRequiredStepsComplete = function (stepEl) {
    var stepIndex = parseInt(stepEl.dataset.stepIndex, 10) || 0;
    for (var i = 0; i < this.steps.length; i++) {
      var other = this.steps[i];
      var otherIndex = parseInt(other.dataset.stepIndex, 10) || i + 1;
      if (otherIndex >= stepIndex) break;
      if (other.dataset.required === 'false') continue;
      if (!this.isStepComplete(other)) return false;
    }
    return true;
  };

  AromaBundlePicker.prototype.updateStepAlerts = function () {
    var self = this;
    this.steps.forEach(function (stepEl) {
      var alertEl = stepEl.querySelector('[data-aroma-step-alert]');
      if (!alertEl) return;

      var stepIndex = parseInt(stepEl.dataset.stepIndex, 10) || 1;
      var required = stepEl.dataset.required !== 'false';
      var incomplete = required && !self.isStepComplete(stepEl);
      var show =
        incomplete &&
        (stepIndex === 1 || self.arePriorRequiredStepsComplete(stepEl));

      alertEl.hidden = !show;
      alertEl.classList.toggle('is-visible', show);
      stepEl.classList.toggle('biscuits-bundle-step--needs-selection', show);
    });
  };

  AromaBundlePicker.prototype.updateBundleStatus = function () {
    var statusEl = this.root.querySelector('[data-aroma-bundle-status]');
    var textEl = this.root.querySelector('[data-aroma-bundle-status-text]');
    if (!statusEl || !textEl) return;

    this.updateStepAlerts();

    var incompleteDefault =
      this.root.dataset.msgIncomplete || 'Please complete all required selections above.';
    var complete = this.isBundleComplete();

    if (complete) {
      statusEl.classList.remove('biscuits-bundle-status--incomplete');
      statusEl.classList.add('biscuits-bundle-status--complete', 'is-hidden');
      textEl.textContent = '';
      return;
    }

    statusEl.classList.remove('biscuits-bundle-status--complete', 'is-hidden');
    statusEl.classList.add('biscuits-bundle-status--incomplete');

    var missing = this.getIncompleteStepTitles();
    if (missing.length) {
      textEl.textContent = incompleteDefault + ' (' + missing.join(', ') + ')';
    } else {
      textEl.textContent = incompleteDefault;
    }
  };

  AromaBundlePicker.prototype.isVariantPurchasable = function () {
    if (!this.form) return true;
    var select = this.form.querySelector('[data-product-select]');
    if (!select || select.selectedIndex < 0) return true;
    var option = select.options[select.selectedIndex];
    return option && !option.disabled;
  };

  AromaBundlePicker.prototype.isBundleComplete = function () {
    var self = this;
    return this.steps.every(function (stepEl) {
      var required = stepEl.dataset.required !== 'false';
      if (!required) return true;
      var minSel = parseInt(stepEl.dataset.minSelections, 10) || 1;
      return self.getStepSelectedCount(stepEl) >= minSel;
    });
  };

  AromaBundlePicker.prototype.updateAddToCartState = function () {
    if (!this.ensureForm()) return;
    var btn = this.form.querySelector('[data-add-to-cart]');
    if (!btn) return;

    var complete = this.isBundleComplete();
    var variantOk = this.isVariantPurchasable();

    if (complete && variantOk) {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.aromaBundleLocked;
      return;
    }

    if (!complete) {
      btn.disabled = true;
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.dataset.aromaBundleLocked = 'true';
    }
  };

  AromaBundlePicker.prototype.initCustomSliderForStep = function (stepEl) {
    var viewport = stepEl.querySelector('[data-aroma-step-slider]');
    if (!viewport || viewport.dataset.aromaSliderInit === 'true') return;
    viewport.dataset.aromaSliderInit = 'true';

    var track = viewport.querySelector('.aroma-bundle-slider__track');
    var prevBtn = stepEl.querySelector('[data-aroma-slider-prev]');
    var nextBtn = stepEl.querySelector('[data-aroma-slider-next]');
    if (!track) return;

    var gap =
      parseInt(getComputedStyle(this.root).getPropertyValue('--aroma-bundle-gap'), 10) || 10;

    function slideStep() {
      var slide = track.querySelector('.aroma-bundle-slider__slide');
      if (!slide) return viewport.clientWidth;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 2) {
        if (prevBtn) {
          prevBtn.disabled = true;
          prevBtn.classList.add('is-disabled');
        }
        if (nextBtn) {
          nextBtn.disabled = true;
          nextBtn.classList.add('is-disabled');
        }
        return;
      }
      if (prevBtn) {
        var atStart = viewport.scrollLeft <= 1;
        prevBtn.disabled = atStart;
        prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (nextBtn) {
        var atEnd = viewport.scrollLeft >= maxScroll - 1;
        nextBtn.disabled = atEnd;
        nextBtn.classList.toggle('is-disabled', atEnd);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -slideStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: slideStep(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  };

  AromaBundlePicker.prototype.setItemSelected = function (itemEl, groupEl, selected) {
    var checkbox = itemEl.querySelector('[data-aroma-item-checkbox]');
    if (checkbox) checkbox.checked = selected;
    itemEl.classList.toggle('biscuits--active', selected);
    if (groupEl) {
      groupEl.classList.toggle('biscuits--active', selected);
      groupEl.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }

    var stepEl = itemEl.closest('[data-aroma-bundle-step]');
    if (stepEl && selected) {
      var indexEl = itemEl.querySelector('[data-aroma-selection-index]');
      if (indexEl) {
        var order = 1;
        stepEl.querySelectorAll('[data-aroma-item-checkbox]:checked').forEach(function (cb, i) {
          if (cb === checkbox) order = i + 1;
        });
        indexEl.textContent = String(order);
      }
    }
  };

  AromaBundlePicker.prototype.clearStepSelection = function (stepEl, exceptItem) {
    stepEl.querySelectorAll('[data-aroma-bundle-item]').forEach(function (item) {
      if (exceptItem && item === exceptItem) return;
      var group = item.querySelector('.biscuits-bundle-item__container-group');
      this.setItemSelected(item, group, false);
    }, this);
  };

  AromaBundlePicker.prototype.enforceMaxSelections = function (stepEl) {
    var maxSel = parseInt(stepEl.dataset.maxSelections, 10) || 1;
    var checked = stepEl.querySelectorAll('[data-aroma-item-checkbox]:checked');
    for (var i = maxSel; i < checked.length; i++) {
      var item = checked[i].closest('[data-aroma-bundle-item]');
      if (!item) continue;
      var group = item.querySelector('.biscuits-bundle-item__container-group');
      this.setItemSelected(item, group, false);
    }
  };

  AromaBundlePicker.prototype.updateStepCount = function (stepEl) {
    var countEl = stepEl.querySelector('[data-aroma-step-selected]');
    var count = this.getStepSelectedCount(stepEl);
    if (countEl) countEl.textContent = String(count);

    var order = 0;
    stepEl.querySelectorAll('[data-aroma-bundle-item]').forEach(function (item) {
      var cb = item.querySelector('[data-aroma-item-checkbox]');
      var indexEl = item.querySelector('[data-aroma-selection-index]');
      if (!indexEl) return;
      if (cb && cb.checked) {
        order += 1;
        indexEl.textContent = String(order);
      }
    });
  };

  AromaBundlePicker.prototype.syncLineItemProperties = function () {
    if (!this.ensureForm()) return;

    var self = this;
    var mount = this.propertiesMount || this.form;
    mount.querySelectorAll('[data-aroma-bundle-property]').forEach(function (el) {
      el.remove();
    });

    this.steps.forEach(function (stepEl) {
      stepEl.querySelectorAll('[data-aroma-item-checkbox]:checked').forEach(function (cb) {
        var item = cb.closest('[data-aroma-bundle-item]');
        if (!item) return;

        var label =
          item.dataset.propertyKey ||
          stepEl.dataset.stepPropertyKey ||
          ('Step ' + (stepEl.dataset.stepIndex || ''));
        /* Cart line item value = title only (subtitle is display-only on the card). */
        var value = (item.dataset.itemTitle || '')
          .replace(/<[^>]*>/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (!label || !value) return;

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + label + ']';
        input.value = value;
        input.setAttribute('data-aroma-bundle-property', '');
        mount.appendChild(input);
      });
    });
  };

  function boot() {
    document.querySelectorAll('[data-aroma-bundle-picker]').forEach(function (root) {
      var existing = root.__aromaBundlePickerInstance;
      if (existing) {
        existing.ensureForm();
        existing.bindCartRefresh();
        existing.updateAddToCartState();
        existing.syncLineItemProperties();
        existing.updateBundleStatus();
        return;
      }
      root.dataset.aromaBundleInitialized = 'true';
      root.__aromaBundlePickerInstance = new AromaBundlePicker(root);
    });
  }

  function bootWhenReady() {
    boot();
    window.setTimeout(boot, 0);
    window.setTimeout(boot, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhenReady);
  } else {
    bootWhenReady();
  }

  document.addEventListener('shopify:section:load', bootWhenReady);
})();
